import ApolloOptionsQuery from "./apolloOptionsQuery";

export { ApolloOptionsQuery };
